const links = {
  billings: "/billing",
  batchBilling: "/billing/batch",
  batchBillingDetail: "/billing/batch/detail",
  billingManualCreation: "/billing/manual",
  billingDetail: "/billing/detail",
  batchBillingCNAB: "/billing/batch/cnab",
  batchBillingCNABDetail: "/billing/batch/cnab/detail",
  customers: "/customers",
  customerDetail: "/customers/detail",
  customerConfig: "/customers/config",
  customerManualCreation: "/customers/create",
  batchCustomers: "/customers/batch",
  batchCustomersDetail: "/customers/batch/detail",
  subscriptionManualCreation: "/subscription/manual",
  withdraw: "/withdraw",
  pay: "/pay",
  payInvalid: "/pay/invalid",
  payFail: "/pay/fail",
  paySuccess: "/pay/success",
  payPending: "/pay/pending",
  statements: "/statements",
  boleto: "/boleto",
  dashboard: "/dashboard",
  home: "/",
  none: "",
  generalConfig: "/config",
  emailConfig: "/config/email",
  generalConfigIntegration: "/config/integration",
  configRoles: "/config/roles",
  configCollaborators: "/config/collaborators",
  configCollaboratorDetail: "/config/collaborators/detail",
  configProfile: "/config/user",
  configCompany: "/config/company",
  configBankData: "/config/bank",
  configTags: "/config/tags",
  configCheckCNPJCPF: "/config/check-cnpj-cpf",
  configCheckCNPJCPFDetail: "/config/check-cnpj-cpf/detail",
  configCheckCNPJCPFHistory: "/config/check-cnpj-cpf/history",
  support: "/support",
  supportCall: "/support/call",
  userSignIn: "/user/sign-in",
  userLogOut: "/user/logout",
};

export default links;
